import { jsx as e, jsxs as r } from "react/jsx-runtime";
import { R as C, P as w, O as y, C as b, a as f, T as g } from "../../../../index-6Ym2qqt2.js";
import { c as s } from "../../../../clsx-OuTLNxxd.js";
import { I as n } from "../../../../icon-BnqXyiyH.js";
import "../../icon/iconsList.js";
import { useImageCarousel as I } from "./imageCarousel.hook.js";
const R = "_modal_7lezd_29", j = "_arrow_7lezd_121", k = "_prev_7lezd_132", O = "_next_7lezd_136", l = {
  "modal-overlay": "_modal-overlay_7lezd_29",
  modal: R,
  "modal-content": "_modal-content_7lezd_62",
  "modal-header": "_modal-header_7lezd_65",
  "modal-title": "_modal-title_7lezd_77",
  "modal-close": "_modal-close_7lezd_93",
  "current-slide": "_current-slide_7lezd_109",
  "slider-container": "_slider-container_7lezd_115",
  arrow: j,
  prev: k,
  next: O,
  "slider-wrapper": "_slider-wrapper_7lezd_140",
  "slider-item": "_slider-item_7lezd_144"
};
function E({
  images: a = [],
  isOpen: t,
  openSlide: i,
  closeLabel: m,
  className: _,
  onClose: h,
  onChange: p,
  ...v
}) {
  const { handleChange: u, currentIndex: d, move: c, sliderRef: z } = I(
    a.length,
    t,
    i,
    h,
    p
  ), x = [...a].sort((o, N) => o.order_display - N.order_display);
  return /* @__PURE__ */ e(C, { open: t, onOpenChange: u, ...v, children: /* @__PURE__ */ r(w, { children: [
    /* @__PURE__ */ e(y, { className: l["modal-overlay"] }),
    /* @__PURE__ */ r(b, { className: s(l.modal, _), children: [
      /* @__PURE__ */ r("div", { className: l["modal-header"], children: [
        /* @__PURE__ */ e(f, { asChild: !0, children: /* @__PURE__ */ r("button", { className: l["modal-close"], "aria-label": "Close", children: [
          /* @__PURE__ */ e(n, { name: "remove", color: "inverted", size: "large" }),
          " ",
          /* @__PURE__ */ e("span", { children: m })
        ] }) }),
        /* @__PURE__ */ e(g, { className: l["modal-title"], children: /* @__PURE__ */ e("span", { children: a[d].title }) })
      ] }),
      /* @__PURE__ */ e("div", { className: l["modal-content"], children: /* @__PURE__ */ r("div", { className: l["slider-container"], children: [
        /* @__PURE__ */ e("div", { className: l["slider-wrapper"], ref: z, children: x.map((o) => /* @__PURE__ */ e("div", { className: l["slider-item"], children: /* @__PURE__ */ e("img", { src: o.src, alt: o.title ?? "" }) }, o.src)) }),
        d !== a.length - 1 && /* @__PURE__ */ e(
          "button",
          {
            className: s(l.arrow, l.next),
            color: "secondary",
            onClick: () => c("next"),
            "aria-label": "carouse-next-button",
            children: /* @__PURE__ */ e(n, { name: "circle-right-arrow", color: "inverted", size: "5xl" })
          }
        ),
        d !== 0 && /* @__PURE__ */ e(
          "button",
          {
            className: s(l.arrow, l.prev),
            color: "secondary",
            onClick: () => c("prev"),
            "aria-label": "carouse-next-button",
            children: /* @__PURE__ */ e(n, { name: "circle-right-arrow", color: "inverted", size: "5xl" })
          }
        )
      ] }) }),
      /* @__PURE__ */ r("span", { className: l["current-slide"], children: [
        d + 1,
        "/",
        a.length
      ] })
    ] })
  ] }) });
}
export {
  E as ImageCarousel
};
